import { Component, OnInit, Renderer2, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';
import { AuthService } from 'src/app/security/auth.service';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { EmpresaLista } from 'src/app/shared/model/tickets/empresaLista.model';
import { TipoSolicitud } from 'src/app/shared/model/tickets/tipoSolicitud.model';
import { SweetAlertComponent } from 'src/app/shared/SweetMesssage';
import swal from 'sweetalert2';
import { TicketsService } from '../../tickets.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-solicitud-tickets-edit',
    standalone: true,
    templateUrl: './solicitud-tickets-edit.component.html',
    styleUrls: ['./solicitud-tickets-edit.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatSelect, NgFor, MatOption, MatLabel, NgIf, MatError, MatDialogActions, MatButton]
})
export class SolicitudTicketsEditComponent implements OnInit {

  @Input() ticket: Tickets;
  tickets: Tickets;
  options: FormGroup;
  areas: Area[];
  prioridades: Prioridad[];
  empresas: EmpresaLista[];
  areaSeleccionada: Area;
  areaSeleccionadaRes: Area;
  empresaSeleccionada: EmpresaLista;
  tipoSolicitud: TipoSolicitud[];
  prioridadesFiltradas: Prioridad[];
  nombreEmpresa: String;


  
  constructor(private router: Router, private fb: FormBuilder, public modal: MatDialogRef<SolicitudTicketsEditComponent>,
    private ticketsService: TicketsService, private authS: AuthService, private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: any, private mensaje: SweetAlertComponent) { }


    ngOnInit() {
      this.tickets = Object.assign({}, this.data.datos)// estructura para Clonar un objeto
   
      this.options = this.fb.group({
        asuntoCtrl: ['', Validators.required],
        nombreCtrl: ['', Validators.required],
        empresaCtrl: ['', Validators.required],
        areaCtrl: ['', Validators.required],
        areaResCtrl: ['', Validators.required],
        fechaSolicitudCtrl: ['', Validators.required],
        prioridadCtrl: ['', Validators.required],
        justificacionCtrl: ['', Validators.required],
        telefonoCtrl: [''],
        TipoSolicitudCtrl: ['', Validators.required],
      });
    

      this.ticketsService.consultarTipoSolicitud().subscribe(resp => {
        if (resp != null) {
          this.tipoSolicitud = resp.list;
        }
      });
  
      this.ticketsService.consultarPrioridad().subscribe(resp => {
        if (resp != null) {
          this.prioridades = resp.list;
          this.prioridadesFiltradas=resp.list;
        }
      });
  
      this.ticketsService.consultarEmpresa(UrlConstantes.consultarEmpresaLista).subscribe(res => {
        if (res != null) {
          for (let i = 0; i < res.list.length; i++) {
          if(res.list[i].id === this.tickets.id_Empresa){
            this.nombreEmpresa=res.list[i].razon_social;
          }
        }
      }
      });
    }


    salir() {
      this.modal.close();
    }
    cerrar() {
      this.modal.close(this.tickets);
    }

   

    formatFecha(str: any): string {
      const date = new Date(str),
        mnth = ('0' + (date.getMonth() + 1)).slice(-2),
        day = ('0' + date.getDate()).slice(-2);
      return [day, mnth, date.getFullYear()].join('/');
    }
  
    orgValueChange() {
      this.prioridadesFiltradas = [];
      for (let i = 0; i < this.prioridades.length; i++) {
        if(this.prioridades[i].nombre === 'Alta'){
         if(this.tickets.tipoSolicitud === 'Incidencia'){
          this.prioridadesFiltradas.push(this.prioridades[i]);
         }
        }else{
          this.prioridadesFiltradas.push(this.prioridades[i]);
        }
      }
         this.tickets.prioridad=null;
    }

    guardar(): void {
        
      this.ticketsService.editarTicket(this.tickets).subscribe(res => {
        if (res != null && res.pCodRetorno === '00000') {
          swal.fire({
            title: '¡Se ha editado la solicitud de Ticket! ',
            timer: 6000,
            icon: 'success',
            showConfirmButton: true
          }).then(responeMsg => {
            if (res.pCodRetorno === '00000') {
              this.modal.close(this.tickets);
            } else {
              //this.inputAsuntoCtrl.nativeElement.focus();
            }
          });
        } else {
          swal.fire({
            title: ' Fallo la edición del Ticket.',
            timer: 6000,
            icon: 'error',
            showConfirmButton: true
          });
        }
      });
    }

    
}
